<script setup></script>

<template>
  <div class="container container--main">
    <slot />
  </div>
</template>

<style lang="scss" scoped></style>
